import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { useGetUserInfo } from 'hooks/useGetUserInfo';
import { Navbar } from "components/layout/components/Navbar";
import DocumentHistoryPage from "./components/history";
import "../cvChat/assets/style.css";

export default function HistoryPage() {
  
  const navigate = useNavigate();

  const { userInfo } = useGetUserInfo();

  useEffect(() => {
    if (userInfo?.type === "talent") {
      navigate("/");
    }
  }, [userInfo, navigate]);

  return (
    <>
      <script
        src="https://cdn.jsdelivr.net/pyodide/v0.23.4/full/pyodide.js"
        async
      ></script>
      <DashboardLayout>
        <Navbar title="Document Upload History" description="" />

        <div className="flex-1 overflow-auto p-4">
          <DocumentHistoryPage />
        </div>
      </DashboardLayout>
    </>
  );
}
